import { render, staticRenderFns } from "./FormProductColorComponent.vue?vue&type=template&id=6c709f80&scoped=true"
import script from "./FormProductColorComponent.vue?vue&type=script&lang=js"
export * from "./FormProductColorComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductColorComponent.vue?vue&type=style&index=0&id=6c709f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c709f80",
  null
  
)

export default component.exports